<template>
  <div>
    <v-card-text>

      <v-row>
        <v-col
          cols="12"
          sm="4"
        >

          <v-text-field
            ref="MID"
            v-model=dataTef.mid
            label="(MID) Código de comercio"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="TID"
            v-model=dataTef.tid
            label="(TID) Código de dispositivo TEF"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="CID"
            v-model=dataTef.cid
            label="(CID) Terminal Hiopos"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="lot"
            v-model=dataTef.lote
            label="Lote"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="reference"
            v-model=dataTef.referencia
            label="Referencia"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="ip"
            v-model=dataTef.ip_pinpad
            label="IP dispositivo PinPad"
            prepend-inner-icon="mdi-account-tie"

            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="port"
            v-model=dataTef.puerto
            label="Puerto"
            prepend-inner-icon="mdi-account-tie"
            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="mask"
            v-model=dataTef.mascara
            label="Marcara"
            prepend-inner-icon="mdi-account-tie"
            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            ref="gateway"
            v-model=dataTef.gateway
            label="Gateway"
            prepend-inner-icon="mdi-account-tie"
            required
          />
        </v-col>
      </v-row>
      <v-card-actions class="justify-end">

        <v-btn
          text
          style="background-color:rgb(204 33 40);color:white !important"
          @click="updateDataTef()"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
      <v-alert
        v-show="successAlert"
        type="success"
        text
      >
        {{ msgSuccessAlert }}
      </v-alert>
    </v-card-text>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'camposPinPad',
  props: ['dataTef', 'token_key', 'code_store'],

  data () {
    return {
      dataUpdateTef: [],
      msgSuccessAlert: 'Datos actualizados exitosamente',
      successAlert: false,
    }
  },
  computed: {
    ...mapState('credentialsTef', [
      'updateStatusTimeOutResponse'
    ]),

    updateStatusResponse () {
      return this.$store.state.credentialsTef.updateStatusResponse
    },
  },
  watch:
    {
      updateStatusResponse  () {
        if (this.updateStatusResponse === true) {
          this.generateAlertSuccess()
          this.$store.dispatch('credentialsTef/setUpdateResponseCredentials', false)
        }
      },
    },
  methods: {
    generateAlertSuccess () {
      this.successAlert = true
      // location.reload();
      setTimeout(() => {
        this.successAlert = false
      }, 3000)
    },
    async updateDataTef () {
      this.dataUpdateTef.dataCredentials = this.dataTef
      this.dataUpdateTef.token_key = this.token_key
      this.dataUpdateTef.code_store = this.code_store
      this.dataUpdateTef.user = JSON.parse(atob(localStorage.getItem('uid'))).user
      this.dataUpdateTef.observation = 'Updated Credentials'
      await this.$store.dispatch('credentialsTef/updateCredentials', this.dataUpdateTef)
    },
  },
}
</script>

<style scoped>

</style>
